export enum ConfiguratorValues {
  'InternalServerError' = 'We are sorry! We are experiencing some technical difficulties in fulfilling your request. Please try again in some time!',
  'AddToCartFail' = 'We are sorry, we are not able to add your items to the cart. Please try again after some time.',
  'SequencePriority' = 'sequencePriority',
  'antisencesequencePriority' = 'antisencesequencePriority',
}

// ProductNames for GA
export enum ProductNames {
  standard = 'Standard DNA Tubes',
  PROBE = 'Dual-Labeled',
  easyoligo = 'Easy™ Oligos',
  puresimple = 'Pure & Simple Primers',
  BEACON = 'Molecular Beacons',
  wellred = 'WellRED Oligos',
  rna = 'RNA Oligos',
  aqua = 'AQUA Peptides',
  longoligo = 'Long Oligos',
  cpeptide = 'Custom Peptides',
  duplex = 'Custom siRNA',
  fastduplex = 'Fast siRNA',
  lightcycle = 'LightCycler® Probes',
  duplexplate = 'Custom siRNA plates',
  dnaplate = 'Standard DNA Plates',
  antisera = 'Antisera Peptides',
  simpleantisera = 'Simple Antisera Peptides',
  customcrispr = 'Custom CRISPR',
  milliplex = 'Milliplex Multiplex Assays',
  crispr = 'Sanger CRISPR',
  orf = 'ORF',
  shrna = 'Predesigned shRNA',
  sirna = 'Predesigned siRNA',
  crisprgrna = 'Predesigned CRISPR gRNA',
  kicqstartProbe = 'KiCqStart® Probe Assays',
  kicqstartGeneArrays = 'KiCqStart® Primers Gene Arrays',
  iscaledna = 'Milligram Quantity (iScale Oligos™) - DNA',
  mirna = 'Custom miRNA in Tubes',
}

export enum InvalidKeys {
  KEY_NOT_PRESENT = 'KEY_NOT_PRESENT',
}

export const contactEmail = 'oligotechserv@merckgroup.com'

export const templateUrl = {
  gRNA: '/configurator-upload/bulk-entry/template/customcrispr/US',
  nikase: '/configurator-upload/bulk-entry/template/customcrispr/US',
}

export const defaultEmail = 'custsvc@milliporesigma.com'
export const defaultPhone = '1-800-234-5362'
export const messageRegexPattern = /[^a-zA-Z0-9]/g

export const CHINA_WEBHELP_EMAIL = 'ChinaWebHelp@merckgroup.com'

export enum CategoryType {
  accessories = 'accessories',
  consumables = 'consumables',
  services = 'services',
  summary = 'summary',
}
